import productionConfiguration from '../config/default.json';
import readConfig from './readClientConfiguration';

export const resolveLinkProps = link => {
  let isExternalUrl;
  const linkProps = {};

  try {
    const base_url = readConfig(productionConfiguration, 'base_url');
    const urlObj = new URL(link);
    const baseUrlObj = new URL(base_url);
    
    const isInternalHost = urlObj.host === baseUrlObj.host;
    isExternalUrl = !isInternalHost;
    
    if (isExternalUrl) {
      linkProps['href'] = link;
    } else {
      linkProps['to'] = urlObj.pathname;
    }
  } catch (e) {
    linkProps['to'] = link;
  }

  return linkProps;
};
